import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from 'primeng/toast';
import { environment } from '../environments/environment';
import { TransactionTimer } from './shared/components/transaction-timer/transaction-timer';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TransactionTimer, Toast],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private translate = inject(TranslateService);

  constructor() {
    this.translate.addLangs(['en', 'bn']);
    this.translate.setFallbackLang('en');
    this.translate.use('en');
    console.log('environment :>> ', environment.apiUrl);
  }

  ngOnInit() {
    const language: boolean = this.translate.currentLang === 'bn';
    if (language) {
      document.body.classList.add('bangali');
    }
  }
}
